import React from 'react'
import {Redirect} from 'react-router-dom'
import {Link, Dialog, Button, SplitColumnsContainer, Icon} from 'startlibs/lib/components'
import {withForm, Errors, Form, TextInput} from 'startlibs/lib/form'
import {formFetch,postFetcher} from 'startlibs'
import {withToggles} from 'startlibs/lib/hocs'
import {setNotifications} from '../reducers'
import {connect} from 'react-redux'
import {buildValidation, confirmPasswords, minLength, required, responseFailure} from '../lib/validation'
import styled from 'styled-components'
import {ice} from 'icepath'
import {FieldRequirements} from '../signin/SignUp'

const SettingsWrapper = styled.div`
  .card {
    padding: 2rem 2rem 3rem;
  }
  h3 {
    position: relative;
    font-size: 16px;
    ${Icon} {
      color: rgba(0,0,0,0.4);
      font-size: 21px;
      position: absolute;
    }
    .title {
      padding-left: 2rem;
    }
  }
  h4 {
    font-size: 15px;
    margin-bottom: .5rem;
  }
`

const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  padding-top: 1rem;
}`

const ChangePassHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 1rem;
  p {
    margin-bottom: 0;
  }
  .heading-text {
    flex-grow: 1;
  }
  ${Button} {
    flex-basis: 20rem;
    margin-left: 2rem;
  }
  @media (max-width: 600px) {
    .heading-text {
      flex-shrink: 1;
      flex-basis: 0;
    }
  }
  @media (max-width: 475px) {
    ${Button} {
      flex-basis: 14rem;
    }
  }
  @media (max-width: 380px) {
    flex-wrap: wrap;
    .heading-text {
      flex-grow: 1;
      flex-basis: 100%;
    }
    ${Button} {
      flex-basis: 100%;
      margin-left: 0;
      margin-top: 1rem;
    }
  }
`

const EMPTY_FORM = {password:''}

@withForm(formFetch)
@connect(({user})=>({user}),{setNotifications})
@withToggles('redirect', 'sendingEmailAccount','sendingEmailReports', 'confirmDeleteDialog', 'sendingResetPassword')
export class AccountSettings extends React.Component {

  preValidation = buildValidation({
    newPassword:[minLength(6),required],
    confirmPassword: confirmPasswords('newPassword')
  },({newPassword,oldPassword})=>({newPassword,oldPassword}))

  onSuccess = () => {
    this.props.setNotifications(["Changes saved successfully"])
    this.props.redirect.open()
  }

  onFailure = responseFailure(this.props.form,(response) => response.title === "Incorrect password" && {oldPassword:["Incorrect current password, please retry typing it."]})

  openDeleteAccount = () => {
    this.props.sendingEmailAccount.open()
    postFetcher('/api/account/data-cleanup/init','')
      .then(({errors}) => {
        this.props.sendingEmailAccount.close()
        if (!errors) {
          this.props.confirmDeleteDialog.open("account")
        }
      }).catch(e=> this.onFailure)
  }

  openDeleteReports = () => {
    this.props.sendingEmailReports.open()
    postFetcher('/api/account/report-cleanup/init','')
      .then(({errors}) => {
        this.props.sendingEmailReports.close()
        if (!errors) {
          this.props.confirmDeleteDialog.open("reports")
        }
      })
  }

  resetPassword = () => {
    this.props.sendingResetPassword.open()
    postFetcher("/api/account/reset-password/init",this.props.user.email)
      .then(() => {
        this.props.sendingResetPassword.close()
        this.props.setNotifications(["Password reset email sent successfully."])
      })
      .catch(() => {
        this.props.sendingResetPassword.close()
      })
  }

  render() {
    const {form, redirect, sendingEmailAccount, sendingResetPassword, sendingEmailReports, confirmDeleteDialog} = this.props
    return (
      <div className="content edit-profile">
        <div ><Button.Link className="return-home-button" icon="arrow-left" to="/">Home</Button.Link></div>
        <div className="profile-header">
          <h1>Account settings</h1>
          <div className="profile-menu">
            <Link className="button nav-tab" to="/profile">Profile</Link>
            <Link className="button nav-tab active" skipTo="/account-settings">Account settings</Link>
            <Link className="button nav-tab" to="/workstations">Manage workstations</Link>
          </div>
        </div>
        <SettingsWrapper>
          <ChangePassHeading>
            <div className="heading-text">
              <h3>Change password</h3>
              <p>To change your password fill in the fields below.</p>
            </div>
            <Button icon="email" isLoading={sendingResetPassword.isOpen} onClick={this.resetPassword}>Forgot password? Reset by email</Button>
          </ChangePassHeading>
          <div className="card">
            <Form
              form={form}
              defaultProperties={EMPTY_FORM}
              preValidation={this.preValidation}
              url="/api/account/change-password"
              onFailure={this.onFailure}
              onSuccess={this.onSuccess}
            >
              <TextInput
                form={form}
                type="password"
                path="oldPassword"
                label="Old password:"
                placeholder="Enter your old password"
              />
              <SplitColumnsContainer viewportMinWidth={610}>
                <TextInput
                  form={form}
                  type="password"
                  path="newPassword"
                  label="New password:"
                  placeholder="Enter your new password"
                />
                <TextInput
                  form={form}
                  type="password"
                  path="confirmPassword"
                  label="Confirm new password:"
                  placeholder="Confirm your new password"
                />
              </SplitColumnsContainer>
              <FieldRequirements>
                Your password shall contain at least 6 characteres.
              </FieldRequirements>
              <Errors form={form}/>
              <CardFooter>
                <div>
                  <Button onClick={()=> { form.connector.setValues(i=>ice({})); form.connector.setHasChanged(false) }} disabled={!form.hasChanged}>Cancel</Button>
                  <Button type="submit" disabled={!form.hasChanged} isLoading={form.isLoading} highlight>Change password</Button>
                </div>
              </CardFooter>
            </Form>
            {
              redirect.isOpen &&
              <Redirect to="/"/>
            }
          </div>

          <h3><Icon icon="warning" /><span className="title">Delete account data</span></h3>
          <p>For deleting your account or its reports data, read carefully and advance below.</p>
          <div className="card">
            <h4>Requesting data deletion</h4>
            <p>You will receive an email to confirm your request before we perform the data deletion.</p>
            <CardFooter>
              <Button onClick={this.openDeleteAccount} isLoading={sendingEmailAccount.isOpen} hover="alert">Delete account and reports</Button>
              <Button onClick={this.openDeleteReports} isLoading={sendingEmailReports.isOpen} hover="alert">Delete all reports</Button>
            </CardFooter>
          </div>
          {
            confirmDeleteDialog.isOpen && <Dialog
            title="Check your email to confirm deletion"
            closeDialog={confirmDeleteDialog.close}>
              <Dialog.Content icon="warning">
                {confirmDeleteDialog.isOpen === "account" ?
                  <div>
                    <p>
                      <strong>You have requested to delete your account and all your reports. </strong>
                      Please check your email and confirm your request to proceed. The confirmation link expires in 1h if not used.
                    </p>
                    <p>Ignore the email if you don't want to proceed with the account and reports deletion.</p>
                    <p>Be aware that the deletion of account and reports is irreversible once you confirm the request.</p>
                  </div>
                :
                  <div>
                    <p>
                      <strong>You have requested to delete all reports in your account. </strong>
                      Please check your email and confirm your request to proceed. The confirmation link expires in 1h if not used.
                    </p>
                    <p>Ignore the email if you don't want to proceed with the reports deletion.</p>
                    <p>Be aware that the deletion of reports is irreversible once you confirm the request.</p>
                  </div>
                }
              </Dialog.Content>
              <Dialog.Footer>
                <Button onClick={confirmDeleteDialog.close}>Close</Button>
              </Dialog.Footer>
            </Dialog>
          }
        </SettingsWrapper>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/user/AccountSettings.jsx